module.exports = __webpack_public_path__ + "static/media/world.e133ae01.jpg";